import { Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  InfoWrapper: styled(Flex, {
    color: '$nonInteractivePredominant',
    flexDirection: 'column',

    "&[data-complete='false']": {
      color: '$nonInteractiveAuxiliar',
      justifyContent: 'center',
    },

    "&[data-active='true']": {
      color: '$backgroundAltSecondary',
      justifyContent: 'start',
    },

    "&[data-tracking='true']": {
      justifyContent: 'start',
    },

    '@tablet': {
      marginTop: '0',
    },
  }),

  IconWrapper: styled('div', {
    background: '$backgroundPrimary',
    border: '2px solid $backgroundPrimary',
    borderRadius: '$pill',
    boxShadow: '$downSoft',
    color: '$nonInteractiveAltAuxiliar',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '$8',
    minWidth: '$8',
    maxHeight: '$8',
    maxWidth: '$8',

    svg: {
      width: '$4',
      height: '$4',
    },

    "&[data-complete='true']": {
      border: '2px solid $nonInteractiveEmphasis',
      color: '$nonInteractiveEmphasis',
    },

    "&[data-active='true']": {
      color: '$nonInteractivePredominant',
    },

    "&[data-canceled='true']": {
      borderColor: '$statusErrorBackgroundAlt',
    },
  }),

  Line: styled('span', {
    background: '$backgroundSecondary',
    height: '$8',
    width: '2px',

    "&[data-complete='true']": {
      background: '$nonInteractiveEmphasis',
    },

    "&[data-tracking='true']": {
      height: '$16',
    },

    '@tablet': {
      height: '2px',
      width: '100%',

      "&[data-tracking='true']": {
        height: '2px',
      },
    },
  }),

  Status: styled('div', {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',

    '@tablet': {
      flexDirection: 'row',
      margin: '0 -40% 0 40%',
    },
  }),

  TrackingButton: styled('div', {
    alignSelf: 'start',
    marginTop: '$2',

    '@tablet': {
      alignSelf: 'center',
    },
  }),

  Wrapper: styled(Flex, {
    gap: '$6',
    alignItems: 'flex-start',

    '&:last-of-type': {
      '[data-line]': {
        display: 'none',
      },
    },

    '@tablet': {
      flexDirection: 'column',
      alignItems: 'initial',
      gap: '$2',
      justifyContent: 'center',
      textAlign: 'center',
    },
  }),
};

export default styles;
